// @ts-check
// Nombres de los eventos propios que cruzan de un componente a otro. Uno
// los lanza y otro los escucha, en módulos distintos: si cada uno escribiera
// el nombre a mano, un cambio en uno dejaría sordo al otro sin que fallara
// nada (DEC-179, revisión de deriva). Lo vigila `eventos.spec.js`.

/**
 * Un diálogo se acaba de abrir (`components/modal-dialog.js#abrir`). Sube
 * hasta el documento. Lo escucha `base/momentos.js`, que pausa el momento del
 * HUD mientras el diálogo tapa la pantalla.
 */
export const EVENTO_DIALOGO_ABIERTO = 'ui-dialogo-abierto';
